export const patterns = {
  /**
   * @prop name - match not present in: a-z, A-Z, ', ., -
   */
  name: /[^a-zA-Z\x7f-\xff'.\s-]/,
  postcodes: {
    uk: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/,
    ir: /^[A-Za-z]\d{2} ?[A-Za-z0-9]{4}$/,
    usa: /^\d{5}(?:[-\s]\d{4})?$/,
    de: /^\d{5}$/,
  },
};

export enum MinLengths {
  firstName = 1,
  lastName = 2,
}
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum MaxLengths {
  email = 128,
  phone = 50,
  address1 = 50,
  address2 = 50,
  city = 50,
  postcode = 10,
  countrycode = 4,
}
